module.exports = "/images/vendor/flag-icon-css/flags/1x1/mm.svg?8d6d26bc590adff8e84dc5a3342a2bfc";